import { useEffect, useRef, useState } from "react";
import moment from "moment";
import DatePicker from "react-multi-date-picker";

interface SelectIProps {
  label?: string;
  // selected?: string | any;
  options: any[];
  // multiSelect?: boolean;
  // value?: any;
  // setValue?: any;
  // handleSelect?: any;
  // handleRemove?: any;
  // selectedOptions?: string[];
  setFormValues?: any;
  formValues?: any;
  slectedLable: string;
  setslectedLable: any;
  setSelectedDate: any;
  setselectedValue: any;
  selectedValue: string;
  // selectedDate: any;
  setIsOpen?: any;
  isOpen?: any;
  formField?: any;
  filtersView?: boolean;
  subscriptionView?: boolean;
  isDashboard?: boolean;
}
function CustomDateSelect({
  label,
  options,
  setFormValues,
  formValues,
  setslectedLable,
  setSelectedDate,
  slectedLable,
  setselectedValue,
  selectedValue,
  isOpen,
  setIsOpen,
  formField,
  subscriptionView,
  filtersView,
  isDashboard = false,
}: SelectIProps) {
  const selectRef = useRef<any>(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [customDateSelect, setcustomDateSelect] = useState({
    startDate: "",
    endDate: "",
  });

  const [value, setValue] = useState();
  useEffect(() => {
    if (selectedValue === "Last30Days") {
      setSelectedDate({
        startDate: moment().subtract(30, "days").format("YYYY/MM/DD"),
        endDate: moment().format("YYYY/MM/DD"),
      });

      //
      setIsCalendarOpen(false);
      setValue(undefined);
    }
    // eslint-disable-next-line
  }, [selectedValue]);

  useEffect(() => {
    if (datePickerRef.current) {
      datePickerRef.current.openCalendar();
      if (customDateSelect.startDate === "" && customDateSelect.endDate === "") {
        setslectedLable("");
      } else {
        setslectedLable(`${customDateSelect.startDate} ~ ${customDateSelect.endDate}`);
      }
    }
    // eslint-disable-next-line
  }, [slectedLable === "Custom Range"]);

  const handleSelectValue = (val: string, lable: string) => {
    if (val === "CustomRange") {
      setIsCalendarOpen(true);
      setslectedLable("");
      setSelectedDate({ startDate: "", endDate: "" });
      if (datePickerRef.current) {
        datePickerRef.current.openCalendar();
      }
      setIsOpen(true);
    }

    setselectedValue(val);
    setslectedLable(lable);

    if (val === "Today") {
      setSelectedDate({
        startDate: moment().format("YYYY/MM/DD"),
        endDate: moment().format("YYYY/MM/DD"),
      });
      setIsOpen(false);
      setIsCalendarOpen(false);
      setValue(undefined);
      setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });
    } else if (val === "Yesterday") {
      setSelectedDate({
        startDate: moment().subtract(1, "days").format("YYYY/MM/DD"),
        endDate: moment().subtract(1, "days").format("YYYY/MM/DD"),
      });
      setIsOpen(false);
      setIsCalendarOpen(false);
      setValue(undefined);
      setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });
    } else if (val === "LastWeek") {
      setSelectedDate({
        startDate: moment().subtract(1, "week").format("YYYY/MM/DD"),
        endDate: moment().format("YYYY/MM/DD"),
      });
      setIsOpen(false);
      setIsCalendarOpen(false);
      setValue(undefined);
      setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });
    } else if (val === "Last7Days") {
      setSelectedDate({
        startDate: moment().subtract(7, "days").format("YYYY/MM/DD"),
        endDate: moment().format("YYYY/MM/DD"),
      });
      setIsOpen(false);
      setIsCalendarOpen(false);
      setValue(undefined);
      setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });
    } else if (val === "ThisMonth") {
      setSelectedDate({
        startDate: moment().startOf("month").format("YYYY/MM/DD"),
        endDate: moment().endOf("month").format("YYYY/MM/DD"),
      });
      setIsCalendarOpen(false);
      setIsOpen(false);
      setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });
      setValue(undefined);
    } else if (val === "LastMonth") {
      setSelectedDate({
        startDate: moment().subtract(1, "month").startOf("month").format("YYYY/MM/DD"),
        endDate: moment().subtract(1, "month").endOf("month").format("YYYY/MM/DD"),
      });
      setIsCalendarOpen(false);
      setIsOpen(false);
      setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });
      setValue(undefined);
    } else if (val === "ThisWeek") {
      setSelectedDate({
        startDate: moment().startOf("week").format("YYYY/MM/DD"),
        endDate: moment().endOf("week").format("YYYY/MM/DD"),
      });
      setIsCalendarOpen(false);
      setIsOpen(false);
      setValue(undefined);
      setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });
    } else if (val === "Last30Days" || lable === "Last 30 days") {
      setSelectedDate({
        startDate: moment().subtract(30, "days").format("YYYY/MM/DD"),
        endDate: moment().format("YYYY/MM/DD"),
      });
      setIsCalendarOpen(false);
      setIsOpen(false);
      setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });

      setValue(undefined);
    } else if (val === "ThisQuarter") {
      setSelectedDate({
        startDate: moment().startOf("quarter").format("YYYY/MM/DD"),
        endDate: moment().endOf("quarter").format("YYYY/MM/DD"),
      });
      setIsCalendarOpen(false);
      setIsOpen(false);
      setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });
      setValue(undefined);
    } else if (val === "LastQuarter") {
      const lastQuarter = moment().subtract(1, "quarter");

      setSelectedDate({
        startDate: lastQuarter.startOf("quarter").format("YYYY/MM/DD"),
        endDate: lastQuarter.endOf("quarter").format("YYYY/MM/DD"),
      });
      setIsCalendarOpen(false);
      setIsOpen(false);
      setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });
      setValue(undefined);
    } else if (val === "Last90Days") {
      setSelectedDate({
        startDate: moment().subtract(90, "days").format("YYYY/MM/DD"),
        endDate: moment().format("YYYY/MM/DD"),
      });
      setIsOpen(false);
      setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });
      setValue(undefined);
    } else if (val === "ThisYear") {
      setSelectedDate({
        startDate: moment().startOf("year").format("YYYY/MM/DD"),
        endDate: moment().endOf("year").format("YYYY/MM/DD"),
      });
      setIsOpen(false);
      setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });
      setValue(undefined);
    } else if (val === "LastYear") {
      const lastYear = moment().subtract(1, "year");

      setSelectedDate({
        startDate: lastYear.startOf("year").format("YYYY/MM/DD"),
        endDate: lastYear.endOf("year").format("YYYY/MM/DD"),
      });
      setIsOpen(false);
      setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });
      setValue(undefined);
    } else if (val === "last7Days" || lable === "Last 7 days") {
      setSelectedDate({
        startDate: moment().subtract(7, "days").format("YYYY/MM/DD"),
        endDate: moment().format("YYYY/MM/DD"),
      });
      setValue(undefined);
      setIsOpen(false);
      setValue(undefined);
      setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });
    }
  };

  const datePickerRef = useRef<any>();

  const weekDays = [
    ["sun", "Su"], //[["name","shortName"], ... ]
    ["mon", "Mo"],
    ["tue", "Tu"],
    ["wed", "We"],
    ["thu", "Th"],
    ["fri", "Fr"],
    ["sat", "Sa"],
  ];
  const handleCustomSelectValue = (event: any) => {
    let years = event.map((e: any) => e.year);
    let months = event?.map((e: any) => e.month.number);
    let days = event?.map((e: any) => e.day);
    setValue(event);
    setcustomDateSelect({
      startDate: `${years[0]}/${months[0]}/${days[0]}`,
      endDate: `${years[1]}/${months[1]}/${days[1]}`,
    });
  };
  const handleConfirm = () => {
    datePickerRef?.current?.closeCalendar();
    setSelectedDate({
      startDate: customDateSelect.startDate,
      endDate: customDateSelect.endDate,
    });
    setIsOpen(false);
    setslectedLable(`${customDateSelect.startDate} ~ ${customDateSelect.endDate}`);
  };

  const handleOutsideClick = (event: any) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line
  }, []);
  return (
    <div style={{ position: "absolute", right: subscriptionView ? 15 : 0, background: "rgb(255, 255, 255)", zIndex: 1000 }}>
      <div className="custom-multi-select shadow" ref={selectRef}>
        <div className="select-field-date">
          <div>
            {selectedValue === "" ? (
              <span>Select Date</span>
            ) : selectedValue ? (
              // <span style={{ fontWeight: 400, fontSize: "13px" }}>{slectedLable}</span>
              ""
            ) : (
              ""
            )}
          </div>
        </div>
        {isOpen && (
          <div className=" custom-select-dropdwon">
            <div className="selectedSubItemsDate" style={{ paddingBottom: "15px" }}>
              {isCalendarOpen ? (
                <DatePicker
                  value={value}
                  onChange={handleCustomSelectValue}
                  range
                  // numberOfMonths={2}
                  // multiple
                  showOtherDays
                  ref={datePickerRef}
                  weekDays={weekDays}
                  calendarPosition="right-start"
                  arrow={false}
                  style={{ marginLeft: "30px" }}
                >
                  <div className="date-btn-wrapper">
                    {customDateSelect.startDate && value !== undefined && customDateSelect.endDate !== undefined ? (
                      <div className="date-to-show" style={{ marginBottom: "22px", fontSize: "14px" }}>{`${customDateSelect.startDate}-${
                        customDateSelect.endDate !== "undefined/undefined/undefined" ? customDateSelect.endDate : ""
                      }`}</div>
                    ) : null}

                    <button
                      className="cancel-date-button"
                      onClick={() => {
                        datePickerRef?.current?.closeCalendar();
                        setValue(undefined);
                        setIsOpen(false);
                        setslectedLable("Last 30 Days");
                        setSelectedDate({
                          startDate: moment().subtract(30, "days").format("YYYY/MM/DD"),
                          endDate: moment().format("YYYY/MM/DD"),
                        });
                        setcustomDateSelect({ ...customDateSelect, startDate: "", endDate: "" });
                        setselectedValue("Last30Days");
                      }}
                    >
                      Cancel
                    </button>
                    <button className="apply-date-button" onClick={handleConfirm}>
                      Done
                    </button>
                  </div>
                </DatePicker>
              ) : null}
              {options?.map((item, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => {
                      handleSelectValue(item.value, item.lable);
                    }}
                    style={{
                      marginTop: index === options.length - 1 ? "20px" : "",
                      marginBottom: index === options.length - 1 ? "10px" : "",
                      background: selectedValue === item.value ? "#F2F2F2" : "transparent",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: 400,
                      lineHeight: "15px",
                      paddingLeft: "17px",
                      paddingRight: "17px",
                      color: "#4F4F4F",
                      borderBottom:
                        isDashboard && (index === 1 || index === 4 || index === 7 || index === 10 || index === 12)
                          ? "1px solid rgba(236, 236, 236, 1)"
                          : 0,
                    }}
                    className=" py-2 date-dropdown-options"
                  >
                    {item?.lable}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomDateSelect;
